import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css";
import logo from "../assets/images/Krinvy_Logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle scroll effect for navbar background
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on larger screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Navigation items
  const navItems = [
    { path: "/", name: "Home" },
    { path: "/about", name: "About Us" },
    { path: "/services", name: "Services" },
    { path: "/products", name: "Products" },
    { path: "/outsourcing", name: "Outsourcing" },
  ];

  // Handle navigation with scroll reset
  const handleNavigation = (path) => {
    setIsOpen(false);
    // Scroll to top before navigation
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <nav className={`krinvy-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="krinvy-navbar-container">
        <div className="krinvy-left-section">
          <button 
            className="krinvy-menu-toggle" 
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <FaTimes className="krinvy-menu-icon" />
            ) : (
              <FaBars className="krinvy-menu-icon" />
            )}
          </button>
          <Link 
            to="/" 
            className="krinvy-logo"
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/");
            }}
          >
            <img src={logo} alt="Krinvy Logo" />
            <span className="krinvy-brand-name">Krinvy</span>
          </Link>
        </div>

        <ul className={`krinvy-nav-links ${isOpen ? "krinvy-open" : ""}`}>
          {navItems.map((item, index) => (
            <li key={index}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? "krinvy-active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(item.path);
                }}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;